<div class="loading-container" [ngStyle]="loadingStyle" *ngIf="!useOldStyle; else oldStyle">
  <img *ngIf="!inv" src="assets/img/loading.gif" alt="Spinner logo" />
  <img *ngIf="inv" src="assets/img/loading_inv.gif" alt="Spinner logo" />
</div>

<ng-template #oldStyle>
  <app-svg-icon [icon]="'tiny-bot-spinner'" [width]="size" [height]="size"></app-svg-icon>
  <div *ngIf="!customText; else customTextBlock" [hidden]="hideText" class="placeholder-text" appProtocolDroid="misc.loading">Loading ...</div>
  <ng-template #customTextBlock>
    <div [hidden]="hideText" class="placeholder-text">{{ customText }}</div>
  </ng-template>
</ng-template>
